import { useState } from "react";
import { useSelector } from "react-redux";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashCan } from "@fortawesome/free-regular-svg-icons";
import ModalEditInTest from "./ModalEditInTest";
import Swal from "sweetalert2";

export const LGH = ({
  data = [],
  handleChange,
  alias,
  setData,
  fields,
  setSelectedValues,
  LXH,
}) => {
  const { lang, functions, proxy, database } = useSelector((state) => state);
  const [isModalEdit, setModalEdit] = useState(false);
  const [dataModalEdit, setDataModalEdit] = useState({
    data: [],
    alias: "",
  });
  const [refreshTable, setRefreshTable] = useState(0);

  const inputFields = [
    {
      label: "Mã Lịch Phân Phối",
      required: true,
      alias: "1MPP",
      readOnly: true,
      type: "text",
    },
    {
      label: "Số Chuyến",
      required: true,
      alias: "delivery_detail_id",
      readOnly: true,
      type: "text",
    },
    {
      label: "LXH/LĐĐNB",
      required: true,
      alias: "lenhXuatHangERP",
      readOnly: true,
      type: "text",
    },
    { label: "Mã Thành Phẩm", alias: "25MSP", readOnly: true, type: "text" },
    {
      label: "SL Tấn Còn Lại",
      alias: "SL Tấn Còn Lại",
      readOnly: true,
      type: "text",
    },
    // { label: "Số Hóa Đơn", alias: "4SHĐ", readOnly: false, type: "text" },
    {
      label: "Số Lượng Tấn Cần Xuất",
      label: "Số Lượng Tấn Cần Xuất",
      alias: "4SLCXTT",
      readOnly: false,
      type: "number",
    },
    // {
    //   label: "Vị Trí Lấy Hàng",
    //   alias: "13VTLH",
    //   readOnly: false,
    //   type: "text",
    // },
    {
      label: "Gợi Ý Lệnh Đóng Bao",
      alias: "3MLĐB",
      type: "text",
      readOnly: false,
      renderTable: true,
      child: [
        { label: "Mã Lệnh Đóng Bao", alias: "3MLĐB" },
        { label: "Mã Thành Phẩm", alias: ["23MSP", "10TSP"] },
        { label: "SL Đóng Bao Chưa Xuất", alias: "" },
      ],
    },
    { label: "Ghi Chú", alias: "2GCS", readOnly: false, type: "textarea" },
  ];

  return (
    <div key={refreshTable}>
      <div className="mt-3">
        <div
          className="table-responsive table-custom design-table"
          style={{ height: "auto" }}
          // key={refreshPage}
        >
          <table>
            <thead>
              <tr>
                <td className="index" style={{ zIndex: "9" }}>
                  #
                </td>
                {inputFields.map(({ label, renderTable }, index) =>
                  renderTable !== false ? <td key={index}>{label}</td> : null
                )}
                <td
                  class="align-center position-sticky"
                  style={{
                    right: "0px",
                  }}
                >
                  {lang["Actions"]}
                </td>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  {inputFields.map(
                    (
                      { label, alias: as, readOnly, renderTable, child },
                      _index
                    ) => {
                      let result = Array.isArray(item[as])
                        ? item[as].map((child) => child[as])
                        : typeof item[as] === "object" &&
                          item[as] !== null &&
                          item[as] !== undefined
                        ? `${item[as]?.MaSP}\n${item[as]?.TenSP}`
                        : item[as];
                      const findSTCL = LXH?.find(
                        (lxh) =>
                          lxh["2MLXH"] === item["4LXH"] &&
                          lxh?.delivery_detail_id == item?.deliveryDetailId
                      );

                      return renderTable !== false ? (
                        <td
                          key={_index}
                          style={{
                            // color: color,
                            textAlign: "left",
                            whiteSpace: "pre",
                          }}
                        >
                          {readOnly ? (
                            result || findSTCL?.[as]
                          ) : (
                            <input
                              className="form-control"
                              value={
                                result !== null && result !== undefined
                                  ? result
                                  : ""
                              }
                              readOnly={child?.length ? true : false}
                              onBlur={(e) => {
                                const { value } = e.target;

                                if (as === "4SLCXTT" && value) {
                                  const roundedValue =
                                    parseFloat(value).toFixed(3);
                                  const parseValue = parseFloat(roundedValue);
                                  result = parseValue;
                                  handleChange(
                                    { alias, index },
                                    { [as]: parseValue }
                                  );
                                }
                              }}
                              onChange={(e) => {
                                const { value } = e.target;
                                const numericValue = parseFloat(value);

                                if (!isNaN(numericValue) && numericValue < 0) {
                                  handleChange({ alias, index }, { [as]: 0 });
                                } else {
                                  handleChange(
                                    { alias, index },
                                    { [as]: value }
                                  );
                                }
                              }}
                            />
                          )}
                        </td>
                      ) : null;
                    }
                  )}
                  <td
                    className="align-center actions"
                    style={{
                      right: "0px",
                      background: "rgb(255, 255, 255)",
                    }}
                  >
                    <div className="icon-table">
                      <div
                        className="icon-table-line text-center"
                        data-toggle="modal"
                        data-target="#ModalEditInTest"
                        data-backdrop="static"
                        onClick={() => {
                          setModalEdit(true);
                          setDataModalEdit({
                            data: item,
                            alias: alias,
                            index: index,
                          });
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faEdit}
                          className="fa fa-edit size-20 pointer icon-edit"
                          title={lang["update"]}
                        />
                      </div>
                      <div
                        class="icon-table-line text-center"
                        data-toggle="modal"
                        data-target="#ModalEditInTest"
                        data-backdrop="static"
                        // onClick={() => {
                        //   Swal.fire({
                        //     title: lang["confirm"],
                        //     text: lang["confirm.content"],
                        //     icon: "warning",
                        //     showCancelButton: true,
                        //     confirmButtonText: lang["btn.delete"],
                        //     cancelButtonText: lang["btn.cancel"],
                        //     confirmButtonColor: "rgb(209, 72, 81)",
                        //   }).then((result) => {
                        //     if (result.isConfirmed) {
                        //       setGetData((prev) =>
                        //         prev.filter(({ _id }) => _id !== item._id)
                        //       );
                        //       if (item.criteria) {
                        //         setDataDelete((prev) => {
                        //           const newPrev = [
                        //             ...prev,
                        //             Object.values(item.criteria),
                        //           ].flat();
                        //           return newPrev;
                        //         });
                        //       }

                        //       setData((prev) => {
                        //         const newPrev = { ...prev };
                        //         if (newPrev[field.id]) {
                        //           newPrev[field.id] = newPrev[
                        //             field.id
                        //           ].filter((_, idx) => idx !== index);
                        //         }
                        //         return newPrev;
                        //       });
                        //       setChangeData((prev) =>
                        //         prev.filter((_, idx) => idx !== index)
                        //       );
                        //     }
                        //   });
                        // }}
                      >
                        <FontAwesomeIcon
                          icon={faTrashCan}
                          className="size-20 pointer icon-delete"
                          title={lang["delete"]}
                          onClick={() => {
                            Swal.fire({
                              title: lang["confirm"],
                              text: lang["confirm.content"],
                              icon: "warning",
                              showCancelButton: true,
                              confirmButtonText: lang["btn.delete"],
                              cancelButtonText: lang["btn.cancel"],
                              confirmButtonColor: "rgb(209, 72, 81)",
                            }).then((result) => {
                              if (result.isConfirmed) {
                                setSelectedValues((prev) =>
                                  prev.filter(
                                    (select) => select.label !== item.label
                                  )
                                );
                                setData((prev) => {
                                  const newPrev = prev;
                                  const filterPrev = newPrev[alias].filter(
                                    (_, _index) => _index !== index
                                  );
                                  if (filterPrev) {
                                    return {
                                      ...newPrev,
                                      [alias]: filterPrev,
                                    };
                                  }
                                  return newPrev;
                                });
                              }
                            });
                          }}
                        />
                      </div>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {/* <section style={{ display: "flex" }}>
        {inputFields.map(({ label }, index) => (
          <div key={index}>{label}</div>
        ))}
      </section>
      {data.map((item, index) => (
        <section key={index} style={{ display: "flex" }}>
          {inputFields.map(({ label, alias }, _index) => (
            <div key={_index}>
              <div>{item[alias]}</div>
            </div>
          ))}
        </section>
      ))} */}

      {isModalEdit ? (
        <ModalEditInTest
          setModalEdit={setModalEdit}
          dataModalEdit={dataModalEdit}
          fields={fields}
          handleChange={handleChange}
          setRefreshTable={setRefreshTable}
          // alias={alias}
          LXH={LXH}
        />
      ) : null}
    </div>
  );
};
